import ApiService from './apiService';

/**
 * Service pour gérer les opérations liées aux fournisseurs
 */
class SupplierService {
    /**
     * Récupérer la liste des fournisseurs avec filtres et pagination
     * @param {Object} params Paramètres de filtrage et pagination
     * @returns {Promise} Réponse de l'API avec la liste des fournisseurs
     */
    getSuppliers(params = {}) {
        return ApiService.get('/suppliers', params);
    }

    /**
     * Rechercher des fournisseurs
     * @param {String} query Terme de recherche
     * @param {Object} options Options additionnelles (active_only, tri, etc.)
     * @returns {Promise} Réponse de l'API avec les résultats de recherche
     */
    searchSuppliers(query, options = {}) {
        return ApiService.get('/suppliers', {
            search: query,
            ...options
        });
    }

    /**
     * Récupérer un fournisseur par son ID
     * @param {Number|String} id ID du fournisseur
     * @param {Object} params Paramètres additionnels
     * @returns {Promise} Réponse de l'API avec les détails du fournisseur
     */
    getSupplier(id, params = {}) {
        return ApiService.get(`/suppliers/${id}`, params);
    }

    /**
     * Créer un nouveau fournisseur
     * @param {Object} supplierData Données du fournisseur à créer
     * @returns {Promise} Réponse de l'API avec le fournisseur créé
     */
    createSupplier(supplierData) {
        return ApiService.post('/suppliers', supplierData);
    }

    /**
     * Mettre à jour un fournisseur existant
     * @param {Number|String} id ID du fournisseur à mettre à jour
     * @param {Object} supplierData Nouvelles données du fournisseur
     * @returns {Promise} Réponse de l'API avec le fournisseur mis à jour
     */
    updateSupplier(id, supplierData) {
        return ApiService.put(`/suppliers/${id}`, supplierData);
    }

    /**
     * Supprimer un fournisseur
     * @param {Number|String} id ID du fournisseur à supprimer
     * @returns {Promise} Réponse de l'API
     */
    deleteSupplier(id) {
        return ApiService.delete(`/suppliers/${id}`);
    }
}

export default new SupplierService();


